import { render, staticRenderFns } from "./ApprovalSpeed.vue?vue&type=template&id=4e9eaffc&scoped=true&"
import script from "./ApprovalSpeed.vue?vue&type=script&lang=js&"
export * from "./ApprovalSpeed.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalSpeed.vue?vue&type=style&index=0&id=4e9eaffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9eaffc",
  null
  
)

export default component.exports